import React, { useEffect, useMemo, useState, } from 'react';
import { pick, omit, fromPairs, keyBy, } from 'lodash';
import { useList, useToggle, useCounter, useAsync, useLocalStorage, } from 'react-use';
import { startOfMonth, startOfDay, endOfDay, addDays, } from 'date-fns';
import { updateDoc, doc, collection, query, where, orderBy as dbOrderBy, limit, getCountFromServer, getAggregateFromServer, sum as dbSum, count as dbCount, } from 'firebase/firestore';
import numeral from 'numeral';
import { useHistory, useLocation } from 'react-router';
import { toast } from 'react-toastify';

import firebase, { db, functions } from '../firebase';
import useUser from './hooks/useUser';
import useDocumentSubscription from './hooks/useDocumentSubscription';
import useQueryParams from './hooks/useQueryParams';
import useFirebaseUser from './hooks/useFirebaseUser';
import usePageViewTracking from './hooks/usePageViewTracking';
import TenantContext from './contexts/tenant';
import TenantSideNav from './TenantSideNav';
import Page from './Page';

const { keys, entries } = Object;

export default function TenantPage (props) {
  const { children, } = props;
  const { user } = useUser();
  const { firebaseUser } = useFirebaseUser();
  const location = useLocation();
  const history = useHistory();
  const queryParams = useQueryParams();
  const tenant = useDocumentSubscription(user && doc(collection(db, 'tenants'), user.tenantId), [user]);

  usePageViewTracking({ user, firebaseUser, });

  const [topOffset, setTopOffset] = useState(51);
  useEffect(() => {
    const header = document.querySelector('.header-nav');
    if (!header) return;
    const observer = new ResizeObserver(([entry]) => setTopOffset(entry.contentRect.height));
    observer.observe(header);
    return () => observer.disconnect();
  }, [tenant]);

  const [isSideNavCollapsed, setIsSideNavCollapsed] = useLocalStorage('isSideNavCollapsed', false);
  const sideNavWidth = isSideNavCollapsed ? 48 : 234;
  const contentOffset = sideNavWidth - 12;

  return tenant != null && (
    <Page tenant={tenant}>
      <TenantContext.Provider value={tenant}>
        <div className="d-flex">
          <TenantSideNav {...{ ...props, tenant, }} isCollapsed={isSideNavCollapsed} onToggle={() => setIsSideNavCollapsed(!isSideNavCollapsed)} style={{ top: topOffset, width: sideNavWidth, minWidth: sideNavWidth, }} />
          <div className="flex-fill d-flex" style={{ marginLeft: contentOffset, marginTop: topOffset, '--side-nav-width': `${contentOffset}px`, }}>
            {[children].flat().map(_ => ({ ..._, props: { ..._.props, tenant, }, }))}
          </div>
        </div>
      </TenantContext.Provider>
    </Page>
  );
};
